/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaProfileValueWithLabelText from 'DesignSystem/TysiaProfileElements/TysiaProfileValueWithLabelText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/LeadPreview/Content/MiscStats/Location/Content"
  
}) {
let leadLocationNameValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'location.name',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaProfileValueWithLabelText
  viewPath={`${viewPath}/TysiaProfileValueWithLabelText`}
 marginTop={dtSpaceXxs}
 isHorizontal={true}
 label="Location"
 data="lead.location.name"
 value={leadLocationNameValueData}
/>
{children}
</React.Fragment>)
}